import { firebase } from '@/plugins/firebase';
import * as userServices from '@/services/userServices';

/*** 
TODO: userの説明を追加
***/
export default {
  namespaced: true,
  state: {
    userType: '',
    birthDate: null,
    nickname: '',
    photoURL: '',
    thumbnailURL: '',
    isStreaming: false,
    ivsChannelArn: '',
    ivsStreamKeyArn: '',
    recentLiveId: '',
    selfIntroduction: '',
    likedPerformers: []
  },
  mutations: {
    loadUserDoc(state, payload) {
      state.userType = payload.userType;
      state.birthDate = payload.birthDate;
      state.nickname = payload.nickname;
      state.photoURL = payload.photoURL;
      state.thumbnailURL = payload.thumbnailURL;
      state.isStreaming = payload.isStreaming;
      state.ivsChannelArn = payload.ivsChannelArn;
      state.ivsStreamKeyArn = payload.ivsStreamKeyArn;
      state.recentLiveId = payload.recentLiveId;
      state.selfIntroduction = payload.selfIntroduction;
    },
    updateIvsChannelArn(state, channelArn) {
      state.ivsChannelArn = channelArn;
    },
    updateIvsStreamKeyArn(state, streamKeyArn) {
      state.ivsStreamKeyArn = streamKeyArn;
    },
    updateRecentLiveId(state, recentLiveId) {
      state.recentLiveId = recentLiveId;
    },
    updateIsStreaming(state, isStreaming) {
      state.isStreaming = isStreaming;
    },
    updateDoron(state, doronAmount) {
      state.doron += doronAmount;
    },
    updateLikedPerformers(state, likedPerformers) {
      state.likedPerformers = likedPerformers;
    },
    addLikedPerformers(state, likedPerformer) {
      state.likedPerformers.push(likedPerformer);
    }
  },
  actions: {
    async loadUserDoc({ commit }, userId) {
      if (!userId) {
        return;
      }
      const userDoc = await userServices.getUserDoc(userId);
      if (userDoc == null) {
        throw new Error('User doc not exist');
      }
      commit('loadUserDoc', userDoc);

      userDoc.likedPerformers?.forEach(async performer => {
        const snapShot = await performer.get();
        const data = snapShot.data();
        if (!data) {
          return;
        }
        commit('addLikedPerformers', {
          userId: performer.id,
          photoURL: data.photoURL,
          nickname: data.nickname
        });
      });
    },
    async addPerformerToLiked({ commit }, payload) {
      const performerDocRef = userServices.getUserDocRef(payload.performerId);
      const userDoc = await userServices.updateUserDoc(payload.userId, {
        likedPerformers: firebase.firestore.FieldValue.arrayUnion(
          performerDocRef
        )
      });

      const newLikedPerformers = await Promise.all(
        userDoc.likedPerformers.map(async p => {
          const snapShot = await p.get();
          const data = snapShot.data();
          if (!data) return;
          return {
            userId: p.id,
            photoURL: data.photoURL,
            nickname: data.nickname
          };
        })
      );

      commit(
        'updateLikedPerformers',
        newLikedPerformers.filter(p => Boolean(p))
      );
    },
    async removePerformerFromLiked({ commit }, payload) {
      let performerDocRef = userServices.getUserDocRef(payload.performerId);
      let userDoc = await userServices.updateUserDoc(payload.userId, {
        likedPerformers: firebase.firestore.FieldValue.arrayRemove(
          performerDocRef
        )
      });

      const newLikedPerformers = await Promise.all(
        userDoc.likedPerformers.map(async p => {
          const snapShot = await p.get();
          const data = snapShot.data();
          if (!data) return;
          return {
            userId: p.id,
            photoURL: data.photoURL,
            nickname: data.nickname
          };
        })
      );

      commit(
        'updateLikedPerformers',
        newLikedPerformers.filter(p => Boolean(p))
      );
    },
    async removePerformersFromLiked({ commit }, payload) {
      var removeList = payload.performerIds.map(pid =>
        userServices.getUserDocRef(pid)
      );

      const userDoc = await userServices.updateUserDoc(payload.userId, {
        likedPerformers: firebase.firestore.FieldValue.arrayRemove(
          ...removeList
        )
      });
      if (!userDoc) return;

      const likedPerformers = await Promise.all(
        userDoc.likedPerformers.map(async p => {
          const snapShot = await p.get();
          const data = snapShot.data();
          return {
            userId: p.id,
            photoURL: data.photoURL,
            nickname: data.nickname
          };
        })
      );

      commit('updateLikedPerformers', likedPerformers);
    }
  },
  getters: {
    isStreaming(state) {
      if (state.recentLiveId) {
        return state.recentLiveId != '';
      } else {
        return false;
      }
    },
    isPerformer(state) {
      if (state.userType) {
        return state.userType === 'performer';
      } else {
        return false;
      }
    },
    recentLiveId(state) {
      return state.recentLiveId;
    },
    likedPerformers(state) {
      return state.likedPerformers;
    },
    // if user is created.
    // when birthDate is null that means userDoc is not exist
    isCreated(state) {
      return state.birthDate != null;
    }
  }
};
